import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import PerButtonCircle from '../../../components/custom_components/ButtonCircle'
import { PerInfoBox } from '../../../components/custom_components/InfoBox'
import { PerInfoBoxDivider } from '../../../components/custom_components/InfoBox/InfoBoxDivider'
import { PerInfoBoxNumberElement } from '../../../components/custom_components/InfoBox/InfoBoxNumberElement'
import { InfoBoxTile } from '../../../components/custom_components/InfoBox/InfoBoxTileTemplate/InfoBoxTile'
import { TargetTemplateModalType } from '../../../components/custom_components/TargetTemplateModal/types'
import { useTargetTemplateModalStore } from '../../../components/custom_components/TargetTemplateModal/TargetTemplateModalStore'

export type TargetsTemplatesInfoBoxProps = {
  resultLength: number
  permissionToChangeTarget: boolean
}

export const CompanySettingsTargetsTemplatesInfoBox: FC<TargetsTemplatesInfoBoxProps> = ({ resultLength, permissionToChangeTarget }) => {
  const [t] = useTranslation()
  const openTargetTemplateModal = useTargetTemplateModalStore((state) => state.openTargetTemplateModal)

  return (
    <>
      <PerInfoBox>
        <InfoBoxTile heading={t('companySettingsView.targetTemplatesTab.infoBox.heading')}>
          <PerInfoBoxNumberElement number={resultLength} />
        </InfoBoxTile>

        {permissionToChangeTarget && (
          <>
            <PerInfoBoxDivider />
            <InfoBoxTile
              heading={t('companySettingsView.targetTemplatesTab.infoBox.add.createNew')}
              contentFlex="fixed"
              headingAlign="center"
              contentAlign="center"
            >
              <PerButtonCircle
                icon="add_stroke"
                color="success"
                variant="pastel"
                tooltip={t('companySettingsView.targetTemplatesTab.infoBox.add.createNewTooltip')}
                size="large"
                onClick={() => openTargetTemplateModal(TargetTemplateModalType.newTarget)}
                testid="add-new-target-template-button"
              />
            </InfoBoxTile>
          </>
        )}
      </PerInfoBox>
    </>
  )
}
